import * as actions from '../../redux/actions';
import HeroSection from '../../common/HeroSection/HeroSection';
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import getSlides from '../../functions/getSlides/getSlides';
import MultiSlider3 from '../../common/MultiSlider/MultiSlider3';

import { AndimarTitle } from '../../common/Title/AndimarTitle';
import getIcons from '../../functions/getIcons/getIcons';
import KuposHelmet from '../../../common/KuposHelmet';
import CommonService from '../../../../services/commonService';
import ThemeTenTitle from '../components/ThemeTenTitle';

const ThemeTenDestinations = props => {
  const operator = CommonService.getLocal('op') || props.home.operator;

  return (
    <div>
      <KuposHelmet />

      <HeroSection
        heroImage={getIcons('DestinationBanner', operator)}
        // heroImage={destinationBanner}
        height={'41vh'}
        title={'Destinos'}
        description={'Home / Destinos'}
        marginTop="-50px"
      />

      <div className="new-container">
        <div style={{ marginTop: 40 }}>
          <ThemeTenTitle title={'DESTINOS'} />
          
        </div>
        <div style={{ marginTop: -20 }}>
          <MultiSlider3
            multiSlides={getSlides('Destination', operator)}
            removeArrowOnDeviceType={[]}
            sanantonioArrowStyle
            operator={operator}
          />
        </div>
      </div>
    </div>
  );
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    themes: state.themes,
    home: state.home,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ThemeTenDestinations);



// WEBPACK FOOTER //
// ./src/features/themes/ThemeTen/ThemeTenPages/ThemeTenDestinations.js